import TaskIcon from '@mui/icons-material/TaskOutlined';

export const MissionIcon = () => <TaskIcon />;
